import React from 'react';
import { useTranslation } from 'react-i18next';
import {IconIdNotFound} from '../../../../components/buttons/IconButtons';

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const ValidatedFailBody = ({title}) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="row">
                <div className="p-0 col-12 d-flex flex-column justify-content-center align-items-center">
                    <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center mb-2">{t(title)}</p>
                    <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("we_could_not_validate_your_documents_this_may_be_due_to_one_of_the_following_reasons")}</p>
                    <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{`• ${t("the_image_quality_is_too_low")}`}</p>
                    <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{`• ${t("the_document_was_not_properly_captured")}`}</p>
                </div>
            </div>

            <div className="d-flex justify-content-center align-items-center">
                <div className="icon-identity-validation-container">
                    <IconIdNotFound className="w-100 h-100" />
                </div>
            </div>
        </>
    )

}

export default ValidatedFailBody
